import React, { useState } from "react";
import ProjectModal from "./ProjectModal";

import project1 from '../assets/pics/sisiglupeweb/sisig1.png';
import project2 from '../assets/pics/sisiglupemobile/s1.JPG';
import project3 from '../assets/pics/wines/wines1.JPG';
import project4 from '../assets/pics/towerdefense/defense1.JPG';
import project5 from '../assets/pics/clotherz/clothing1.JPG';
import project6 from '../assets/pics/samgyupsole/s1.JPG';

/* for modal */
import sisig1 from '../assets/pics/sisiglupeweb/sisig1.png';
import sisig2 from '../assets/pics/sisiglupeweb/sisig2.png';
import sisig3 from '../assets/pics/sisiglupeweb/sisig3.png';
import sisig4 from '../assets/pics/sisiglupeweb/sisig4.png';

import sisigmob1 from '../assets/pics/sisiglupemobile/s1.JPG';
import sisigmob2 from '../assets/pics/sisiglupemobile/s2.JPG';
import sisigmob3 from '../assets/pics/sisiglupemobile/s3.JPG';
import sisigmob4 from '../assets/pics/sisiglupemobile/s4.JPG';

import wines1 from '../assets/pics/wines/wines1.JPG';
import wines2 from '../assets/pics/wines/wines2.JPG';
import wines3 from '../assets/pics/wines/wines3.JPG';
import wines4 from '../assets/pics/wines/wines4.JPG';

import defense1 from '../assets/pics/towerdefense/defense1.JPG';
import defense2 from '../assets/pics/towerdefense/defense2.JPG';
import defense3 from '../assets/pics/towerdefense/defense3.JPG';
import defense4 from '../assets/pics/towerdefense/defense4.JPG';

import clothing1 from '../assets/pics/clotherz/clothing1.JPG';
import clothing2 from '../assets/pics/clotherz/clothing2.JPG';
import clothing3 from '../assets/pics/clotherz/clothing3.JPG';
import clothing4 from '../assets/pics/clotherz/clothing4.JPG';

import samgyupsole1 from '../assets/pics/samgyupsole/s1.JPG';
import samgyupsole2 from '../assets/pics/samgyupsole/s2.JPG';
import samgyupsole3 from '../assets/pics/samgyupsole/s3.JPG';
import samgyupsole4 from '../assets/pics/samgyupsole/s4.JPG';

function Project() {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: "SLIMS: Sales and Inventory Management System",
      description: "Web & Mobile PWA inventory system.",
      text: "SLIMS: Sales and Inventory Management System is a Progressive Web Application built with the MERN stack (MongoDB, Express.js, React.js, Node.js). It streamlines sales and inventory management with RESTful API CRUD operations and authentication, replacing manual processes with a centralized, secure, and efficient system. The web-app enables real-time inventory monitoring, faster transactions, and organized data management, helping businesses reduce errors and improve operational efficiency.",
      tech: ["MongoDB 1", "Express.js", "React.js", "Node.js"],
      image: project1,
      images: [sisig1, sisig2, sisig3, sisig4],
    },
    {
      id: 2,
      title: "SLIMS: Mobile Application (Customers) ",
      description: "Web & Mobile PWA inventory system.",
      text: "SLIMS: Mobile Application (Customers) is a mobile application developed with React Native, Node.js, Express.js, and MongoDB. Designed exclusively for customers, it provides a seamless interface to access products. The app communicates with the backend through RESTful API operations, ensuring secure, efficient, and real-time data interactions between users and the system.",
      tech: ["React Native", "Node.js", "Express.js", "MongoDB"],
      image: project2,
      images: [sisigmob1, sisigmob2, sisigmob3, sisigmob4],
    },
    {
      id: 3,
      title: "R AND G WINES App Using Ionic",
      description: "Mobile application built with Ionic Framework.",
      text: "R AND G WINES is a mobile application developed using Ionic. The app serves as a digital platform for selling wines, providing users with a seamless shopping experience. It features intuitive modules including Home, Products, Contacts, and About the Developers, allowing users to easily browse products, get in touch with the business, and learn about the development team.",
      tech: ["Ionic", "Angular"],
      image: project3,
      images: [wines1, wines2, wines3, wines4],
    },
    {
      id: 4,
      title: "Tower Defense 3D Game Using UNITY",
      description: "A 3D tower defense game built using Unity.",
      text: "Tower Defense 3D is an interactive 3D game developed using Unity. In the game, players defend a USB device from invading viruses by strategically placing towers and managing resources.",
      tech: ["Unity", "C#"],
      image: project4,
      images: [defense1, defense2, defense3, defense4],
    },
    {
      id: 5,
      title: "Clothing E-Commerce Website",
      description: "E-commerce website with cart and checkout features.",
      text: "Clothing E-Commerce Website is a web application designed for selling apparel, including jackets, pants, caps, and shirts.",
      tech: ["HTML", "CSS", "JAVASCRIPT"],
      image: project5,
      images: [clothing1, clothing2, clothing3, clothing4],
    },
    {
      id: 6,
      title: "Automated Transaction Processing System for Samgyupsole",
      description: "C++ based automated transaction system.",
      text: "Automated Transaction Processing System for Samgyupsole is a console-based application developed in C++. The system allows users to order shoes by selecting sizes, brands, and quantity (1–5), with automated calculation of discounts and total cost.",
      tech: ["C++"],
      image: project6,
      images: [samgyupsole1, samgyupsole2, samgyupsole3, samgyupsole4],
    },
  ];

  return (
    <>
      <section className="project" id="project">
        <div className="project-card">
          <h2>
            <span>Projects</span>
          </h2>

          <div className="project-grid">
            {projects.map((project) => (
              <div
                key={project.id}
                className="project-item"
                onClick={() => setSelectedProject(project)}
              >
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                </div>

                <div className="project-minicard">
                  <h3>{project.title}</h3>

                  {project.tech.map((t, index) => (
                    <span key={index}>{t}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </>
  );
}

export default Project;
